import request from '../../axios';

const PostViolationReportStore = async (payload: IViolationReportStore) => {
  const newPayload = {
    description: payload.description,
    store_guid: payload.store_guid,
    Reason_report_guid: payload.Reason_report_guid,
  };
  await request.post(`api/v2/store/violation-report-store`, {...newPayload});
};

export default PostViolationReportStore;
